// PricingPage.jsx
import React, { useState } from 'react';
import './PricingPage.css';
import { Helmet } from 'react-helmet-async';

const PricingPage = () => {
  const [openFaq, setOpenFaq] = useState(null);
  const [viewMode, setViewMode] = useState('details'); // 'compare' or 'details'
  const [selectedPlans, setSelectedPlans] = useState([0, 1, 2]); // all plans selected by default
  const [expandedFeatures, setExpandedFeatures] = useState({});

const contractorPlans = [
  {
    id: 0,
    name: 'Free',
    price: '£0',
    subtitle: 'For small contractors',
    limit: 'Up to 5 subcontractors',
    featureCount: '25+ features',
    ctaText: 'Start Free',
    popular: false,
    features: {
      'PLAN / SCALE': [
        { name: 'Subcontractor limit', value: 'Up to 5' },
        { name: 'Contractor clients included', value: '1' },
        { name: 'Beta access', value: 'Yes' }
      ],
      'ONBOARDING & ACCESS': [
        { name: 'Invite subcontractors by email', value: 'Yes' },
        { name: 'Online subcontractor registration', value: 'Yes' },
        { name: 'Auto contracting and self employment test', value: 'Yes' },
        { name: 'Additonal users', value: 'Basic' },
        { name: 'Auto VAT status checks', value: 'No' }
      ],
      'HMRC & COMPLIANCE': [
        { name: 'Automated CIS verification', value: 'Yes' },
        { name: 'Re-verification support', value: 'Yes' },
        { name: 'Automated CIS deduction calculation', value: 'Yes' },
        { name: 'Gross / 20% / 30% tax status handling', value: 'Yes' },
        { name: 'CIS300 monthly return generation', value: 'Yes' },
        { name: 'CIS300 monthly return submission', value: 'Yes' },
        { name: 'VAT Status checks', value: 'Yes' },
        { name: 'HMRC reminders', value: 'Yes' }
      ],
      'PAYMENT WORKFLOW': [
        { name: 'Online timesheeting', value: 'Yes' },
        { name: 'Online invoicing', value: 'Yes' },
        { name: 'Online payment approvals', value: 'Yes' },
        { name: 'Edit / reject payments', value: 'Yes' },
        { name: 'Automated bank account checks', value: 'Yes' },
        { name: 'VAT reversal charges', value: 'Yes' },
        { name: 'Bulk payment files', value: 'No' },
        { name: 'Bank account connections', value: 'No' }
      ],
      'STATEMENTS, PDFS & COMMS': [
        { name: 'PDF Payment confirmations', value: 'Yes' },
        { name: 'PDF Monthly statements', value: 'Yes' },
        { name: 'Email notifications', value: 'Yes' },
        { name: 'Email reminders', value: 'Yes' },
        { name: 'HMRC Reminders', value: 'Yes' }
      ],
      'REPORTING & CONTROL': [
        { name: 'Dashboard overview', value: 'Basic' },
        { name: 'Administrative reporting', value: 'Basic' },
        { name: 'Audit trail', value: 'Basic' },
        { name: 'Payment history', value: 'Yes' },
        { name: 'Search and filtering', value: 'Yes' }
      ]
    }
  },
  {
    id: 1,
    name: 'Standard',
    price: '£19/mo',
    subtitle: 'For growing contractors',
    limit: 'Up to 20 subcontractors',
    featureCount: '35+ features',
    ctaText: 'Start Free Trial',
    popular: true,
    features: {
      'PLAN / SCALE': [
        { name: 'Subcontractor limit', value: 'Up to 20' },
        { name: 'Contractor clients included', value: '1' },
        { name: 'Beta access', value: 'Yes' }
      ],
      'ONBOARDING & ACCESS': [
        { name: 'Invite subcontractors by email', value: 'Yes' },
        { name: 'Online subcontractor registration', value: 'Yes' },
        { name: 'Auto contracting and self employment test', value: 'Yes' },
        { name: 'Additonal users', value: 'Yes' },
        { name: 'Auto VAT status checks', value: 'Yes' }
      ],
      'HMRC & COMPLIANCE': [
        { name: 'Automated CIS verification', value: 'Yes' },
        { name: 'Re-verification support', value: 'Yes' },
        { name: 'Automated CIS deduction calculation', value: 'Yes' },
        { name: 'Gross / 20% / 30% tax status handling', value: 'Yes' },
        { name: 'CIS300 monthly return generation', value: 'Yes' },
        { name: 'CIS300 monthly return submission', value: 'Yes' },
        { name: 'VAT Status checks', value: 'Yes' },
        { name: 'HMRC reminders', value: 'Yes' }
      ],
      'PAYMENT WORKFLOW': [
        { name: 'Online timesheeting', value: 'Yes' },
        { name: 'Online invoicing', value: 'Yes' },
        { name: 'Online payment approvals', value: 'Yes' },
        { name: 'Edit / reject payments', value: 'Yes' },
        { name: 'Automated bank account checks', value: 'Yes' },
        { name: 'VAT reversal charges', value: 'Yes' },
        { name: 'Bulk payment files', value: 'Coming soon' },
        { name: 'Bank account connections', value: 'Coming soon' }
      ],
      'STATEMENTS, PDFS & COMMS': [
        { name: 'PDF Payment confirmations', value: 'Yes' },
        { name: 'PDF Monthly statements', value: 'Yes' },
        { name: 'Email notifications', value: 'Yes' },
        { name: 'Email reminders', value: 'Yes' },
        { name: 'HMRC Reminders', value: 'Yes' }
      ],
      'REPORTING & CONTROL': [
        { name: 'Dashboard overview', value: 'Yes' },
        { name: 'Administrative reporting', value: 'Yes' },
        { name: 'Audit trail', value: 'Yes' },
        { name: 'Payment history', value: 'Yes' },
        { name: 'Search and filtering', value: 'Yes' }
      ]
    }
  },
  {
    id: 2,
    name: 'Pro',
    price: '£39/mo',
    subtitle: 'For large contractors',
    limit: 'Unlimited subcontractors',
    featureCount: '45+ features',
    ctaText: 'Start Free Trial',
    popular: false,
    features: {
      'PLAN / SCALE': [
        { name: 'Subcontractor limit', value: 'Unlimited' },
        { name: 'Contractor clients included', value: '1' },
        { name: 'Beta access', value: 'Coming soon' }
      ],
      'ONBOARDING & ACCESS': [
        { name: 'Invite subcontractors by email', value: 'Yes' },
        { name: 'Online subcontractor registration', value: 'Yes' },
        { name: 'Auto contracting and self employment test', value: 'Yes' },
        { name: 'Additonal users', value: 'Yes' },
        { name: 'Auto VAT status checks', value: 'Yes' }
      ],
      'HMRC & COMPLIANCE': [
        { name: 'Automated CIS verification', value: 'Yes' },
        { name: 'Re-verification support', value: 'Yes' },
        { name: 'Automated CIS deduction calculation', value: 'Yes' },
        { name: 'Gross / 20% / 30% tax status handling', value: 'Yes' },
        { name: 'CIS300 monthly return generation', value: 'Yes' },
        { name: 'CIS300 monthly return submission', value: 'Yes' },
        { name: 'VAT Status checks', value: 'Yes' },
        { name: 'HMRC reminders', value: 'Yes' }
      ],
      'PAYMENT WORKFLOW': [
        { name: 'Online timesheeting', value: 'Yes' },
        { name: 'Online invoicing', value: 'Yes' },
        { name: 'Online payment approvals', value: 'Yes' },
        { name: 'Edit / reject payments', value: 'Yes' },
        { name: 'Automated bank account checks', value: 'Yes' },
        { name: 'VAT reversal charges', value: 'Yes' },
        { name: 'Bulk payment files', value: 'Coming soon' },
        { name: 'Bank account connections', value: 'Coming soon' }
      ],
      'STATEMENTS, PDFS & COMMS': [
        { name: 'PDF Payment confirmations', value: 'Yes' },
        { name: 'PDF Monthly statements', value: 'Yes' },
        { name: 'Email notifications', value: 'Yes' },
        { name: 'Email reminders', value: 'Yes' },
        { name: 'HMRC Reminders', value: 'Yes' }
      ],
      'REPORTING & CONTROL': [
        { name: 'Dashboard overview', value: 'Yes' },
        { name: 'Administrative reporting', value: 'Yes' },
        { name: 'Audit trail', value: 'Yes' },
        { name: 'Payment history', value: 'Yes' },
        { name: 'Search and filtering', value: 'Yes' }
      ]
    }
  }
];
  const togglePlanSelection = (planId) => {
    if (selectedPlans.includes(planId)) {
      setSelectedPlans(selectedPlans.filter(id => id !== planId));
    } else {
      setSelectedPlans([...selectedPlans, planId]);
    }
  };

  const toggleFeatureExpand = (featureKey) => {
    setExpandedFeatures(prev => ({
      ...prev,
      [featureKey]: !prev[featureKey]
    }));
  };

  const faqs = [
    {
      question: 'Do I have to pay during beta?',
      answer: 'No. All features are free for all users during the beta period.'
    },
    {
      question: 'What happens after beta ends?',
      answer: 'You\'ll stay free if you have up to 5 subcontractors. Paid plans apply above that.'
    },
    {
      question: 'Do I still need my accountant?',
      answer: 'Yes, but you won\'t need them for CIS admin. PayCIS handles calculations, payments, and returns.'
    }
  ];

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  // Get all unique categories
  const allCategories = [...new Set(
    contractorPlans.flatMap(plan => Object.keys(plan.features))
  )];

  // Get all unique features
  const allFeatures = [...new Map(
    contractorPlans.flatMap(plan => 
      Object.entries(plan.features).flatMap(([category, features]) =>
        features.map(f => [f.name, { name: f.name, category, description: f.description, comingSoon: f.comingSoon }])
      )
    )
  ).values()];

  return (
    <>
    <Helmet>
  <title>PayCIS Pricing Plans | CIS Software for UK Contractors & Subcontractors</title>

  <meta
    name="viewport"
    content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=yes"
  />

  <meta
    name="description"
    content="Explore PayCIS pricing plans for UK contractors. Choose Free, Standard or Pro plans to manage CIS deductions, subcontractor payments, and HMRC compliance easily."
  />

  <meta
    name="keywords"
    content="PayCIS pricing, CIS software plans, contractor pricing UK, subcontractor management software, HMRC CIS tool pricing, construction payroll system UK, CIS calculator plans"
  />

  <meta name="author" content="PayCIS" />

  {/* Open Graph */}
  <meta property="og:title" content="PayCIS Pricing Plans | CIS Software UK" />
  <meta
    property="og:description"
    content="Compare PayCIS Free, Standard and Pro plans for managing CIS deductions and subcontractor payments in the UK."
  />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://paycis.co.uk/pricing" />

  {/* Twitter */}
  <meta name="twitter:card" content="summary" />
  <meta name="twitter:title" content="PayCIS Pricing Plans" />
  <meta
    name="twitter:description"
    content="Choose the right PayCIS plan for your construction business and simplify CIS compliance."
  />

  <link rel="canonical" href="https://paycis.co.uk/pricing" />
</Helmet>
    <div className="pricing-page">

      {/* Hero Section */}
      <section className="pricing-page__hero">
        <div className="pricing-page__container">
          <div className="pricing-page__hero-content">
            <h1 className="pricing-page__hero-title">
              Plans that <span className="pricing-page__gradient-text">scale</span> with your business
            </h1>
            <p className="pricing-page__hero-subtitle">
              Simple CIS compliance. Fully automated.
            </p>
            <div className="pricing-page__trust-badges">
              <span className="pricing-page__badge"> No contracts</span>
              <span className="pricing-page__badge"> Free trial</span>
              <span className="pricing-page__badge"> 100% data security</span>
            </div>
            <div className="pricing-page__beta-badge">
              <span className="pricing-page__mark"> 100% free to all users during beta period</span>
            </div>
          </div>
        </div>
      </section>

      {/* Combined Comparison & Details Section */}
      <section className="pricing-page__section pricing-page__section--compare">
        <div className="pricing-page__container">
          {/* <div className="pricing-page__compare-header">
            <h2>Compare & Choose Your Perfect Plan</h2>
            <p>See features side-by-side or dive deep into each plan's details</p>
          </div> */}

          <div className="pricing-page__tabs">
            <button 
              className={`pricing-page__tab ${viewMode === 'compare' ? 'pricing-page__tab--active' : ''}`}
              onClick={() => setViewMode('compare')}
            >
              Features
            </button>
            <button 
              className={`pricing-page__tab ${viewMode === 'details' ? 'pricing-page__tab--active' : ''}`}
              onClick={() => setViewMode('details')}
            >
              Plans
            </button>
          </div>

          {viewMode === 'compare' ? (
            <div className="pricing-page__comparison-container">
              {/* <div className="pricing-page__plan-selector">
                {contractorPlans.map(plan => (
                  <div key={plan.id} className="pricing-page__plan-checkbox">
                    <label>
                      <input 
                        type="checkbox" 
                        checked={selectedPlans.includes(plan.id)}
                        onChange={() => togglePlanSelection(plan.id)}
                      />
                      <div>
                        <span>{plan.name}</span>
                        <small>{plan.price}</small>
                      </div>
                    </label>
                  </div>
                ))}
              </div> */}

              <div className="pricing-page__comparison-table">
                <table className="pricing-page__feature-table">
                  <thead>
                    <tr>
                      <th>Features</th>
                      {selectedPlans.map(planId => {
                        const plan = contractorPlans.find(p => p.id === planId);
                        return (
                          <th key={planId}>
                            {plan.name}<br/>
                            {/* <small style={{color: '#2ea99e'}}>{plan.price}</small> */}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {allCategories.map(category => (
                      <React.Fragment key={category}>
                        <tr className="pricing-page__category-row">
                          <td colSpan={selectedPlans.length + 1}>
                            {category}
                          </td>
                        </tr>
                        {allFeatures
                          .filter(f => f.category === category)
                          .map(feature => {
                            const featureKey = `${category}-${feature.name}`;
                            return (
                              <React.Fragment key={featureKey}>
                                <tr>
                                  <td className="pricing-page__feature-name">
                                    {feature.name}
                                    <button 
                                      className="pricing-page__expand-btn"
                                      onClick={() => toggleFeatureExpand(featureKey)}
                                    >
                                      {/* {expandedFeatures[featureKey] ? '▲ Less' : '▼ More'} */}
                                    </button>
                                    {feature.comingSoon && (
                                      <span className="pricing-page__coming-soon">Coming soon</span>
                                    )}
                                    {expandedFeatures[featureKey] && (
                                      <div className="pricing-page__feature-detail">
                                        <p>{feature.description}</p>
                                      </div>
                                    )}
                                  </td>
                                 {selectedPlans.map(planId => {
  const plan = contractorPlans.find(p => p.id === planId);
  // Find the actual feature value from the plan
  let featureValue = null;
  for (const category of Object.values(plan.features)) {
    const found = category.find(f => f.name === feature.name);
    if (found) {
      featureValue = found.value;
      break;
    }
  }
  
  return (
    <td key={planId} className="pricing-page__feature-status">
      {featureValue ? (
        <span className="pricing-page__check">{featureValue}</span>
      ) : (
        <span className="pricing-page__cross">—</span>
      )}
    </td>
  );
})}
                                </tr>
                              </React.Fragment>
                            );
                          })}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div className="pricing-page__details-view">
              <div className="pricing-page__details-grid">
                {contractorPlans.map(plan => (
                  <div key={plan.id} className="pricing-page__detail-card">
                    <div className="pricing-page__detail-header">
                      <h3>{plan.name}</h3>
                      <div className="pricing-page__detail-price">{plan.price}</div>
                      <div className="pricing-page__detail-limit">{plan.limit}</div>
                      {plan.popular && (
                        <></>
                        // <div className="pricing-page__detail-badge">🔥 Most Popular</div>
                      )}
                    </div>
                    {/* <div className="pricing-page__detail-features">
                      {Object.entries(plan.features).map(([category, features]) => (
                        <div key={category} className="pricing-page__detail-category">
                          <h4>{category}</h4>
                          <ul>
                            {features.map((feature, idx) => (
                              <li key={idx}>
                                {feature.name}
                                {feature.comingSoon && (
                                  <span className="pricing-page__coming-soon" style={{marginLeft: '8px'}}>
                                    Coming soon
                                  </span>
                                )}
                              </li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </div> */}
                    <div className="pricing-page__detail-footer">
                      <button className="pricing-page__btn pricing-page__btn--primary pricing-page__btn--block">
                        {plan.ctaText}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* FAQ Section */}
      <section className="pricing-page__section pricing-page__section--faq">
        <div className="pricing-page__container">
          <h2 className="pricing-page__faq-title">Frequently Asked Questions</h2>
          <div className="pricing-page__faq-container">
            {faqs.map((faq, index) => (
              <div key={index} className="pricing-page__faq-item">
                <button className="pricing-page__faq-question" onClick={() => toggleFaq(index)}>
                  {faq.question}
                  <span className={openFaq === index ? 'rotate' : ''}>+</span>
                </button>
                {openFaq === index && (
                  <div className="pricing-page__faq-answer">{faq.answer}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>


    </div>
          {/* CTA Section */}
      <section className="pricing-page__cta">

          <div className="pricing-page__cta-card">
            <h3>Get Started Today</h3>
            <p className="pricing-page__cta-subtitle">
              Switch to PayCIS and start saving time and money from your next payroll cycle.
            </p>
            <p className="pricing-page__cta-note">
              Enjoy a free extended trial — no setup costs, no contracts.
            </p>
            <div className="pricing-page__cta-buttons">
              <button className="pricing-page__btn pricing-page__btn--cta">Get Started</button>
              {/* <button className="pricing-page__btn pricing-page__btn--outline">Book a Demo</button> */}
            </div>
          </div>
     
      </section>

    </>
  );
};

export default PricingPage;
